import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../../../utilz/i18n';
import EmptyRecords from '../../../../../../components/Common/EmptyRecords';
import RateShopDetailsCard from './RateShopDetailsCard';

const RateDetails = ({ rateShopList = [], selectedRateIndex, setSelectedRateIndex }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <div className="p-15">
      {rateShopList !== false ? (
        <>
          {rateShopList?.length > 0 ? (
            <div className="vh-60 custom-scroll-bar">
              {rateShopList?.map((rateDetails, index) => (
                // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
                <RateShopDetailsCard
                  rateDetails={rateDetails}
                  checked={index === selectedRateIndex}
                  onSelect={() => setSelectedRateIndex(index)}
                />
              ))}
            </div>
          ) : (
            <EmptyRecords />
          )}
        </>
      ) : (
        <EmptyRecords
          title={`t('translation:getQuote.emptyRecords.title')`}
          descriptionOne={t('translation:getQuote.emptyRecords.desc')}
          descriptionTwo=""
        />
      )}
    </div>
  );
};

export default RateDetails;
